var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19,
    width: 43,
    height: 26,
    rx: 1.5,
    fill: "#166BCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C11 19.6716 11.6716 19 12.5 19H52.5C53.3284 19 54 19.6716 54 20.5V23H11V20.5Z",
    fill: "#166BCD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 37.3477,
    width: 13.5965,
    height: 1.25506,
    rx: 0.627531,
    fill: "#7EB3F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 27,
    width: 17,
    height: 2.5,
    rx: 0.775758,
    fill: "#CEE6FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20.5,
    width: 3.5,
    height: 9.5,
    rx: 0.775758,
    transform: "rotate(-90 28 20.5)",
    fill: "#7EB3F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34.5,
    width: 9.62214,
    height: 1.25506,
    rx: 0.627531,
    fill: "#7EB3F1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 14,
    height: 14,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9715 38C26.2567 38 26.5 37.7852 26.5 37.5C26.5 35.0147 24.4853 33 22 33C19.5147 33 17.5 35.0147 17.5 37.5C17.5 37.7852 17.7433 38 18.0285 38H25.9715Z",
    fill: "#166BCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33C23.3807 33 24.5 31.8807 24.5 30.5C24.5 29.1193 23.3807 28 22 28C20.6193 28 19.5 29.1193 19.5 30.5C19.5 31.8807 20.6193 33 22 33Z",
    fill: "#166BCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUpIcon);
export default __webpack_public_path__ + "static/media/SetUpIcon.77b477b109662c65bacaaca1260a9831.svg";
export { ForwardRef as ReactComponent };